/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Compare_Event_Groups_Group_Events_LabelInputs */

const en_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const fr_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Événements de ${i?.name}`)
};

const de_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Ereignisse`)
};

const it_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Eventi`)
};

const ru_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`События ${i?.name}`)
};

const es_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Eventos`)
};

const zh_cn2_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 事件`)
};

const ja_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} イベント`)
};

const hi_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} घटनाएँ`)
};

const pt_pt2_compare_event_groups_group_events_label = /** @type {(inputs: Compare_Event_Groups_Group_Events_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eventos ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{name} Events" |
*
* @param {Compare_Event_Groups_Group_Events_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_group_events_label = /** @type {((inputs: Compare_Event_Groups_Group_Events_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Group_Events_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_group_events_label(inputs)
	if (locale === "de") return de_compare_event_groups_group_events_label(inputs)
	if (locale === "it") return it_compare_event_groups_group_events_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_group_events_label(inputs)
	if (locale === "es") return es_compare_event_groups_group_events_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_group_events_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_group_events_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_group_events_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_group_events_label(inputs)
	return en_compare_event_groups_group_events_label(inputs)
});